import { message } from 'ant-design-vue'

import { fontFamilyMap } from './pdf-draw'
import { FontKey, jsPdfTool } from './pdfFont'

/**
 * @description 添加fabric字体
 * @param fontKey 添加字体类型
 * @param result base64格式字体文件
 */
function addFabricFont(fontKey: FontKey, result: string) {
  const reversedFontMap = Object.entries(fontFamilyMap).reduce(
    (acc, [key, value]) => {
      acc[value as string] = key
      return acc
    },
    {} as Record<string, string>
  )
  // 检查字体是否已经添加过
  const fontFamily = reversedFontMap[fontKey]
  const fontId = `_fabric-font-${fontFamily}`
  if (document.getElementById(fontId)) {
    return // 如果已添加过该字体，直接返回
  }
  const style = document.createElement('style')
  style.innerHTML = `
      @font-face {
        font-family: '${fontFamily}';
        src: url('data:font/woff2;base64,${result}') format('woff2');
      }
    `
  document.head.appendChild(style)
}

/**
 * @description 初始化 fabric 需要的字体
 */
export async function initFabricNeedFont(fontArr?: FontKey[]) {
  fontArr = fontArr || (Object.values(fontFamilyMap) as FontKey[])
  // 为了节省网络资源加载需要字体时利用 pdf 的加载，顺便将 pdf 的字一同加载出来
  for (const font of fontArr) {
    try {
      const result = await jsPdfTool.loadFont(font, 'zh', 'normal')
      if (result) {
        addFabricFont(font, result.font)
      }
    } catch (error) {
      message.error(`${font}字体加载失败,pdf文件内容可能存在损坏,请刷新重试`)
    }
  }
}
